import React from "react";
import PropTypes from "prop-types";
import { GenericProgressBar } from "../../../components/GenericProgressBar";

const propTypes = {
  /**
   * Sum of posture scores
   */
  count: PropTypes.number,
  /**
   * Total posture scores
   */
  total: PropTypes.number,
  /**
   * If true, shows title
   */
  showTitle: PropTypes.bool,
};

const defaultProps = {
  count: 0,
  total: 1,
  showTitle: true,
};

/**
 * Show the completion of the postures in a percentage form
 */
function PostureScore(props) {
  const { count, total, showTitle } = props;

  let progress = 0;
  if (count && total) {
    progress = (count / total) * 100;
  }

  return (
    <GenericProgressBar
      title={showTitle ? "SECURE.POSTURE_SCORE" : undefined}
      values={[progress, 100]}
      colors={["#00515c"]}
      showPercentage
      maxLabelDepth={1}
      showThreeValueFooterAsPercentage
      flexGrow={8}
      isMultiValueProgressBar={false}
      startingValue={0}
    />
  );
}

PostureScore.propTypes = propTypes;
PostureScore.defaultProps = defaultProps;

export default PostureScore;
